import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'
import styled from 'astroturf/react'
import _ThemedDetailsContainer from "index-ThemedDetailsContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/details/index.js?styleId=ThemedDetailsContainer";

const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'

const ThemedDetailsContainer = /*#__PURE__*/styled(Container, null, {
  displayName: "ThemedDetailsContainer",
  styles: _ThemedDetailsContainer
})

const Details = ({ flow = 'column', ...props }) => (
  <ThemedDetailsContainer data-container="details" flow={flow} {...props} />
)

Details.propTypes = {
  flow: PropTypes.oneOf(['column', 'row'])
}

export default Details
